export default "__VITE_ASSET__IkkTrVW3__"